import { useState, useEffect } from 'react'

export default function useDarkMode() {
  const [theme, setTheme] = useState<string>(localStorage.theme || 'light')

  useEffect(() => {
    const root = window.document.documentElement
    root.setAttribute('class', '')
    root.classList.add(theme)
    localStorage.setItem('theme', theme)
  }, [theme])

  return { theme, setTheme }
}
